import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";

class Home extends Component {
  checkUserLogin() {
    const { isAuthenticated, role } = this.props.authentication
    if (isAuthenticated) {
      if (role === "User") {
        this.props.history.push('/app/dashboard');
      } else {
        this.props.history.push('/admin/dashboard');
      }
    }
  }

  componentDidMount() {
    this.checkUserLogin();
  }

  componentDidUpdate() {
    this.checkUserLogin();
  }

  render() {
    return (
      <div>
        <h1>Welcome to Orange Statistics</h1>
        <h5>Please login using your work email address</h5>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.auth,
  };
}

export default connect(mapStateToProps, actions)(Home);